export default __webpack_public_path__ + "static/media/pandas.d874a929.svg";